import { FormErrorProps, FormProps } from '~/common/types/form'

export type ValidatorFunction = (
  values: FormProps,
  errors: FormErrorProps
) => FormErrorProps

type Props = {
  validators: ValidatorFunction[]
  values: FormProps
}

/** バリデーションをまとめて実行する */
const validatorComposer = ({ validators, values }: Props) =>
  validators.reduce((_errors, validator) => validator(values, _errors), {})

export default validatorComposer
